export default "__VITE_ASSET__49a36d87__"